export default "<div class=\"loader\"></div>";